import "../styles/global.css"
export const GlobalStyles = () => {
    return null
}